import axios from 'axios';

export const LUA_SCRIPT_LIST_REQUEST = 'LUA_SCRIPT_LIST_REQUEST';
export const LUA_SCRIPT_LIST_SUCCESS = 'LUA_SCRIPT_LIST_SUCCESS';
export const LUA_SCRIPT_LIST_FAILURE = 'LUA_SCRIPT_LIST_FAILURE';

export const LUA_SCRIPT_VIEW_REQUEST = 'LUA_SCRIPT_VIEW_REQUEST';
export const LUA_SCRIPT_VIEW_SUCCESS = 'LUA_SCRIPT_VIEW_SUCCESS';
export const LUA_SCRIPT_VIEW_FAILURE = 'LUA_SCRIPT_VIEW_FAILURE';

export const LUA_SCRIPT_UPDATE_REQUEST = 'LUA_SCRIPT_UPDATE_REQUEST';
export const LUA_SCRIPT_UPDATE_SUCCESS = 'LUA_SCRIPT_UPDATE_SUCCESS';
export const LUA_SCRIPT_UPDATE_FAILURE = 'LUA_SCRIPT_UPDATE_FAILURE';

export const LUA_SCRIPT_ADD_REQUEST = 'LUA_SCRIPT_ADD_REQUEST';
export const LUA_SCRIPT_ADD_SUCCESS = 'LUA_SCRIPT_ADD_SUCCESS';
export const LUA_SCRIPT_ADD_FAILURE = 'LUA_SCRIPT_ADD_FAILURE';

const base_url = process.env.REACT_APP_API_URL_ADMIN;


export const fetchLuaScripts = () => async (dispatch) => {
  dispatch({ type: LUA_SCRIPT_LIST_REQUEST });
  try {
    const response = await axios.post(base_url, {
      apiName: 'settings',
      command: 'luaScriptList',
    });
    dispatch({ type: LUA_SCRIPT_LIST_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({
      type: LUA_SCRIPT_LIST_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch Lua scripts',
    });
  }
};

export const viewLuaScript = (id) => async (dispatch) => {
  dispatch({ type: LUA_SCRIPT_VIEW_REQUEST });
  try {
    const response = await axios.post(base_url, {
      apiName: 'settings',
      command: 'luaViewScript',
      data: { _id: id },
    });
    dispatch({ type: LUA_SCRIPT_VIEW_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({
      type: LUA_SCRIPT_VIEW_FAILURE,
      payload: error.response?.data?.message || 'Failed to view Lua script',
    });
  }
};

export const updateLuaScript = (id, updateData) => async (dispatch) => {
  dispatch({ type: LUA_SCRIPT_UPDATE_REQUEST });
  try {
    const response = await axios.post(base_url, {
      apiName: 'settings',
      command: 'luaUpdateScript',
      scriptID: id,
      updateData,
    });
    dispatch({ type: LUA_SCRIPT_UPDATE_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({
      type: LUA_SCRIPT_UPDATE_FAILURE,
      payload: error.response?.data?.message || 'Failed to update Lua script',
    });
  }
};

export const addLuaScript = (data) => async (dispatch) => {
  dispatch({ type: LUA_SCRIPT_ADD_REQUEST });
  try {
    const response = await axios.post(base_url, {
      apiName: 'settings',
      command: 'luaSaveScript',
      data,
    });
    dispatch({ type: LUA_SCRIPT_ADD_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({
      type: LUA_SCRIPT_ADD_FAILURE,
      payload: error.response?.data?.message || 'Failed to add Lua script',
    });
  }
};